import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Switch from '@material-ui/core/Switch';
import React, { useEffect, useState } from 'react';
import { getOrganizationPaymentTypes } from '../../Queries/Organization';

const paymentTypeSwitch = (paymentType, editMode, checked, handleChange) => {
    const switchControl = <Switch
        disabled={!editMode}
        checked={checked}
        onChange={() => handleChange(paymentType.id)}
        name={paymentType.paymentTypeName}
    />;

    return (
        <div className='parkchirp-payment-application-row'>
            <div className='parkchirp-payment-application-row-label'>
                {paymentType.paymentTypeName}
            </div>
            <div className='parkchirp-payment-application-row-field'>
                <FormControlLabel
                    control={switchControl}
                    label={checked ? 'Yes' : 'No'}
                />
            </div>
        </div>
    );
}

const loadingPaymentTypes = () => {
    return <div><span>Loading Payment Types...</span></div>
}

const organizationHasNoPaymentTypes = () => {
    return <div><span>Organization has no payment types</span></div>
}

const SettingsPaymentTypes = ({
    facilityPaymentTypes,
    facilityUid,
    organizationId,
    editMode,
    onPaymentTypesChange
}) => {
    const [loading, setLoading] = useState(true);
    const [organizationPaymentTypes, setOrganizationPaymentTypes] = useState([]);

    // NOTE: Find the array intersection between the organization's list of available
    // payment types and the list of enabled for current facility
    useEffect(() => {
        getOrganizationPaymentTypes({ organizationId: organizationId })
            .then((response) => {
                setOrganizationPaymentTypes(response?.data?.getOrganizationPaymentTypes?.paymentTypes || []);
                setLoading(false)
            })
    }, [facilityUid, organizationId]);

    const handleChange = (paymentTypeId) => {
        let updatedPaymentTypes = facilityPaymentTypes;
        
        if (updatedPaymentTypes.length === 0) {
            // If there aren't any facility payment types yet this means it's the first time
            // a user has accessed the facility's payment types, and by default that means
            // all organization payment types are active. This if block enables all org
            // payment types aside from the one being click in the list to be disabled.
            updatedPaymentTypes = organizationPaymentTypes
                .map(({ id }) => id)
                .filter((id) => id !== paymentTypeId);
            
            onPaymentTypesChange(updatedPaymentTypes);
        } else if (updatedPaymentTypes.includes(paymentTypeId)) {
            // Toggle the payment type off if it is clicked and is currently included in
            // the facility's payment types.
            updatedPaymentTypes = updatedPaymentTypes.filter(id => id !== paymentTypeId);

            onPaymentTypesChange(updatedPaymentTypes);
        } else {
            // If the facility has an active list of payment types and the paymentTypeId
            // is not included in it, toggle it on by adding it to the list of
            // facility payment types.
            updatedPaymentTypes.push(paymentTypeId);

            onPaymentTypesChange(updatedPaymentTypes)
        }
    };

    const paymentTypes = organizationPaymentTypes.map((paymentType) => {
        // NOTE: Default behavior is that if the facility has no payment types, then
        // all organization payment types are enabled.
        const checked = facilityPaymentTypes.length === 0 || facilityPaymentTypes.includes(paymentType.id);

        return paymentTypeSwitch(
            paymentType,
            editMode,
            checked,
            handleChange
        );
    });

    if (loading) {
        return loadingPaymentTypes();
    }

    if (!loading && paymentTypes.length === 0) {
        return organizationHasNoPaymentTypes();
    }

    return (
        <FormControl component="fieldset">
            <FormGroup>
                {paymentTypes}
            </FormGroup>
        </FormControl>
    );
}

export default SettingsPaymentTypes;
